import { Container } from '../../../../Components/Container';
import React, { useState } from 'react';
import { Grid } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import PercentIcon from '@mui/icons-material/Percent';
import { Column, Row } from '../../../../Components/Grid';
import { useQuery } from 'react-query';
import { getGapAnalysisReportByID } from '../../../../services/gap-analysis';
import { useParams } from 'react-router-dom';
import { PageLoaderShow } from '../../../../Components/PageLoader/Show';
import { typeLabels, statusControl, maturityLevels } from '../../../../utils/labels_utils';
import { tableHeader } from './table-header';
import { tableControls } from './table-controls';
import { SummaryCard } from '../../../../Components/SummaryCard';
import EntityProgressTable from '../../../../Components/EntityProgressTable';
import ExpandableTable from '../../../../Components/ExpandableTable';
import StatusStackedBarChart from '../../../../Components/StatusStackedBarChart';
import GroupedProgressCard from '../../../../Components/GroupedProgressCard';
import DonutChartCard from '../../../../Components/DonutChartCard';
import PieChartWithLegend from '../../../../Components/PieChartWithLegend';
import ProgressInfoCard from '../../../../Components/ProgressInfoCard';
import ChartLine from '../../../../Components/LineChart';
import CardBarHorizontal from '../../../../Components/CardBarHorizontal';

import { Tabs, Tab, Box } from '@mui/material';
import { Card } from '../../../../Components/Card';
import { PageHelper } from '../../../../Components/PageHelper';

export const GapAnalysisReportDashboard = () => {
  const { id } = useParams();
  const [tabIndex, setTabIndex] = useState(0);

  const { isLoading, error, data } = useQuery('getGapAnalysisReportByID', async () => {
    const data = await getGapAnalysisReportByID(id);
    return data.status === 200 ? data.data : null;
  });

  if (isLoading) return <p>Carregando...</p>;
  if (error) return <p>Erro ao carregar os dados.</p>;
  const data_dashboard = data.result;
  const entitiesByType = data_dashboard.entitiesByType || {};
  const types = Object.keys(entitiesByType);
  const handleChange = (_event, newIndex) => {
    setTabIndex(newIndex);
  };
  const totalEntities = Object.values(data_dashboard.entityCount).reduce((acc, curr) => acc + curr, 0);
  const entidades = Object.keys(data_dashboard.entityCount).map(key => ({
    name: typeLabels[key],
    value: data_dashboard.entityCount[key],
    percent: ((data_dashboard.entityCount[key] / totalEntities) * 100).toFixed(2),
  }));

  const total = Object.values(data_dashboard.maturityCounts).reduce((acc, curr) => acc + curr, 0);
  const maturityData = Object.keys(maturityLevels).map(key => ({
    name: maturityLevels[key],
    value: data_dashboard.maturityCounts[key],
    total: total,
  }));

  const entityCountsByTypeWithStatus = data_dashboard.entityCountsByTypeWithStatus;
  const dataEntityCountsByTypeWithStatus = Object.keys(entityCountsByTypeWithStatus).map(key => ({
    entidade: typeLabels[key],
    ...entityCountsByTypeWithStatus[key],
  }));

  const entityProgress = data_dashboard.entityTypeProcess;
  const dataEntityProgress = Object.keys(entityProgress).map(key => ({
    ...entityProgress[key],
    label: typeLabels[entityProgress[key].label],
  }));

  const progress =
    data_dashboard.totalControls > 0 ? (data_dashboard.linkedControls / data_dashboard.totalControls) * 100 : 0;

  const pieChartData = Object.keys(data_dashboard.statusCounts).map(key => ({
    name: statusControl[key].label,
    value: data_dashboard.statusCounts[key],
    color: statusControl[key].color,
  }));

  const link_ = `gap-analysis/${id}`;
  const dataProgressFramewok = data_dashboard.progressoPorFramework.map(item => ({
    label: item.name,
    value: item.progress,
  }));
  console.log(data_dashboard);
  return (
    <>
      {!isLoading && !error && (
        <Container
          title={`${data?.name} - ${data_dashboard.gapAnalysis?.name}`}
          breadcrumb={`Relatórios  / Gap Analysis / ${data?.name} - ${data_dashboard.gapAnalysis?.name}`}
          linkPage={-1}
        >
          <Row md={'3'} className="mt-1 g-1">
            <Column xs={12} md={4} className="p-1">
              <Grid item xs={12} data-tour="progress-card">
                <ProgressInfoCard
                  title="Progresso da GAP Analysis"
                  description="Percentual do processo de análise de GAP"
                  icon={<PercentIcon sx={{ color: '#0039c4', fontSize: 20 }} />}
                  total={100}
                  value={data_dashboard.overallProgress}
                  progress={data_dashboard.overallProgress}
                  unitLabel={'% Concluído'}
                />
              </Grid>
              <Grid item xs={12} className="mt-1" data-tour="controls-card">
                <ProgressInfoCard
                  title="Controles Vinculados"
                  description="Quantidade de controles vinculados as entidades"
                  icon={<SecurityIcon sx={{ color: '#0039c4', fontSize: 20 }} />}
                  total={data_dashboard.totalControls}
                  value={data_dashboard.linkedControls}
                  progress={progress}
                  unitLabel={'% Vinculados'}
                />
              </Grid>
            </Column>
            <Column xs={12} md={8} className="p-1" data-tour="historical-chart">
              <ChartLine
                title="Histórico de Progresso"
                data={data_dashboard.historicalProgress}
                tooltipLabel="Progresso"
                color="#0039c4"
              />
            </Column>
          </Row>
          <Row className="g-1">
            <Column xs={12} md={4} className="p-1" data-tour="framework-progress">
              <CardBarHorizontal title="Progresso por Framework" data={dataProgressFramewok} valueLabel="Progresso" />
            </Column>
            <Column xs={12} md={5} className="p-1" data-tour="status-chart">
              <PieChartWithLegend title="Distribuição dos Status dos Controles" data={pieChartData} />
            </Column>
            <Column xs={12} md={3} className="p-1" data-tour="maturity-card">
              <GroupedProgressCard title="Nível de Maturidade" data={maturityData} />
            </Column>
          </Row>
          <Row className="g-1">
            <Column xs={12} md={3} className="p-1" data-tour="entity-donut">
              {' '}
              {/* `p-0` remove padding */}
              <DonutChartCard title="Controles por Entidade" total={data_dashboard.linkedControls} data={entidades} />
            </Column>
            <Column xs={12} md={5} className="p-1" data-tour="status-by-entity">
              <StatusStackedBarChart
                title="Status por Entidade"
                data={dataEntityCountsByTypeWithStatus}
                categoryKey="entidade"
              />
            </Column>
            <Column xs={12} md={4} className="p-1">
              <Grid item data-tour="unique-entities">
                <SummaryCard title="Entidades Únicas Vinculadas" value={data_dashboard.uniqueEntityCount} />
              </Grid>
              <Grid item className="mt-1" data-tour="entity-progress">
                <EntityProgressTable title="Progresso das Entidades" data={dataEntityProgress} />
              </Grid>
            </Column>
          </Row>
          <Row className="g-1">
            <Card>
              <Tabs value={tabIndex} onChange={handleChange} data-tour="entity-tabs">
                {types.map((type) => (
                  <Tab key={type} label={typeLabels[type]} />
                ))}
              </Tabs>

              <Box mt={2}>
                {types.map((type, index) => (
                  <div key={type} hidden={tabIndex !== index}>
                    {tabIndex === index && (
                      <ExpandableTable
                        rows={entitiesByType[type]}
                        columns={tableHeader}
                        link={link_}
                        linkExtend="gap-analysis/control"
                        entityColumns={tableControls}
                        enableSearch={true}
                        enableSorting={true}
                        title={`Controles por ${typeLabels[type]}`}
                      />
                    )}
                  </div>
                ))}
              </Box>
            </Card>
          </Row>
          <PageHelper steps={tourSteps} tourKey="gap-analysis-report" />
        </Container>
      )}
      {isLoading && <PageLoaderShow />}
      {error && <div>Erro</div>}
    </>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo ao relatório detalhado de Gap Analysis! Este dashboard apresenta uma visão completa do progresso da análise de conformidade.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="progress-card"]',
    content: 'Este card mostra o progresso geral da sua análise de GAP. O percentual indica quanto do processo de avaliação foi concluído.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="controls-card"]',
    content: 'Aqui é exibido quantos controles foram vinculados às entidades do total disponível.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="historical-chart"]',
    content: 'O gráfico de linha mostra a evolução do progresso ao longo do tempo, permitindo visualizar tendências.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="framework-progress"]',
    content: 'Este gráfico exibe o progresso individual de cada framework de conformidade avaliado.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="status-chart"]',
    content: 'A distribuição dos status dos controles mostra quantos estão implementados, em progresso, não implementados, etc.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="maturity-card"]',
    content: 'O nível de maturidade indica o grau de implementação dos controles, variando de inicial até otimizado.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="entity-donut"]',
    content: 'Este gráfico de rosca mostra a distribuição de controles entre diferentes tipos de entidades (processos, ativos, dados, etc.).',
    disableScrolling: false,
  },
  {
    target: '[data-tour="status-by-entity"]',
    content: 'Visualize o status dos controles agrupados por tipo de entidade, facilitando identificar onde estão as lacunas.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="unique-entities"]',
    content: 'Este card mostra o total de entidades únicas que possuem controles vinculados.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="entity-progress"]',
    content: 'A tabela de progresso detalha o avanço da avaliação para cada tipo de entidade.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="entity-tabs"]',
    content: 'Use as abas para explorar detalhes dos controles vinculados a cada tipo de entidade. Cada aba contém uma tabela expansível com informações específicas.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Use este dashboard para monitorar o progresso da análise de GAP e identificar áreas que necessitam atenção.',
    disableScrolling: true,
    placement: 'center',
  },
];
